const time = {
  "周": "linggo/linggo ",
  "天": "araw",
  "小时": "oras/oras ",
  "分钟": "minuto/minuto",
  "刚刚": "Kamakailan lang",
  "前": " nakaraan",
  "昨天": "Kahapon",
  "星期一": "Lunes",
  "星期二": "Martes",
  "星期三": "Miyerkules",
  "星期四": "Huwebes",
  "星期五": "Biyernes",
  "星期六": "Sabado",
  "星期日": "Linggo",
}

export default time;